(function ($) {
    const initializeHomeHeroCarouselBlock = function () {
        const $carousel = $('.home-hero-carousel');
        const $dotsContainer = $('.slider-dots-container');
        const slideCount = $carousel.children().length;

        const showDots = slideCount > 1;

        $carousel.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: showDots,
            fade: false,
            cssEase: 'ease',
            speed: 600,
            autoplay: true,
            autoplaySpeed: 8000,
            pauseOnHover: true,
            appendDots: $dotsContainer
        });

        // Toggles a light/dark class on the slider dots container to ensure the slider theme matches the text colour
        const updateDotsTheme = () => {
            const $currentSlide = $carousel.find('.slick-slide.slick-current.slick-active');
            const isLight = $currentSlide.find('.home-hero-wrapper').hasClass('light');
            $dotsContainer.toggleClass('light', isLight);
        };

        $carousel.on('init afterChange', function () {
            updateDotsTheme();
        });

        setTimeout(updateDotsTheme, 0);
    };

    $(document).ready(function () {
        if (!$('.slider-dots-container').length) {
            $('.home-hero-carousel').after('<div class="slider-dots-container"></div>');
        }

        initializeHomeHeroCarouselBlock();
    });

})(jQuery);
